export default __webpack_public_path__ + "d00930e3e99fb32c3c0e44a5624d9a56.png";